<template>
    <div class="scroll-y custom-scrollbar" :class="{'screen-blocked' : blockedScreen }">

        <!-- splash -->
        <splash ref="splashComponent"></splash>

        <!-- login -->
        <ion-row>
            <ion-col size="12" size-sm="10" offset-sm="1" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3">
                <div class="padding" v-if="showLogin === true">

                    <!-- step 1 -->
                    <form v-if="activeStep === 1" class="form form-login wrapper" @submit.prevent>
                        <h1 class="h1">Logowanie</h1>
                        <div class="form-group">
                            <label>Podaj swój numer telefonu:</label>
                            <div class="input-wrapper">
                                <input v-model="username" type="tel" maxlength="12"
                                       :class="{'input-error' : errors.username }"
                                       placeholder="Podaj swój numer telefonu" required :disabled="lockUserInput"/>
                                <span v-if="lockUserInput" class="remove text-blue"
                                      @click="unlockUserInput">Zmień</span>
                            </div>
                            <p class="error" v-if="errors.username">
                                <svg class="voxion">
                                    <use xlink:href="#icon-alert"></use>
                                </svg>
                                <span v-text="errors.username"></span>
                            </p>
                            <div class="approval-list">

                                <!-- static approval -->
                                <div class="item-approval" v-if="showRegulations">
                                    <div class="item-input">
                                        <ion-checkbox
                                                slot="start"
                                                @input="checked = target.value"
                                                @ionChange="handleCheckbox($event, 1, 'Oswiadczenie')"
                                                :required="true"
                                                v-model="checkboxes['Oswiadczenie']"
                                                mode="md">
                                        </ion-checkbox>
                                    </div>
                                    <div class="item-description">
                                        <div class="text-bold">Oświadczenie</div>
                                        <p>Oświadczam, iż zapoznałem się z Regulaminem Programu <a href="#"
                                                                                                   @click="goToRegulations">VOX PARTNERS CLUB</a>
                                        </p>
                                    </div>
                                </div>

                                <!-- dynamic approval -->
                                <div v-if="approvalsCollection && approvalsCollection.length > 0">
                                    <div class="item-approval" v-for="item in approvalsCollection">
                                        <div class="item-input">
                                            <ion-checkbox
                                                    slot="start"
                                                    @input="item.checked = item.target.value"
                                                    @ionChange="handleCheckbox($event, item.id, item.name)"
                                                    :required="item.required"
                                                    v-model="checkboxes[item.name]"
                                                    mode="md">
                                            </ion-checkbox>
                                        </div>
                                        <div class="item-description">
                                            <div class="text-bold">{{ item.name }}</div>
                                            <div v-html="item.content"></div>
                                        </div>
                                    </div>
                                </div>

                                <p class="error" v-if="errors.approvals">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.approvals"></span>
                                </p>
                                <p class="error" v-if="errors.username">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.username"></span>
                                </p>

                            </div>
                        </div>
                        <button class="btn btn-primary" @click="checkUser" :disabled=loginButtonDisabled>
                            <span v-if="loading"><span class="loader"></span></span>
                            <span v-else>Dalej</span>
                        </button>

                    </form>

                    <!-- step 2 -->
                    <form v-if="activeStep === 2" class="form form-login" @submit.prevent="postLogin">
                        <h1 class="h1">Logowanie</h1>
                        <div class="form-group">
                            <label v-text="inputLabel"></label>
                            <input v-model="password" type="password" :class="{'input-error' : errors.password }"
                                   :placeholder="inputLabel" required/>
                            <p class="error" v-if="errors.password">
                                <svg class="voxion">
                                    <use xlink:href="#icon-alert"></use>
                                </svg>
                                <span v-text="errors.password"></span>
                            </p>
                        </div>
                        <a href="#" class="link" @click="goToStep(3)"><span>Nie pamiętam hasła</span></a>
                        <button class="btn btn-primary" type="submit" :disabled=loading>
                            <span v-if="loading"><span class="loader"></span></span>
                            <span v-else>Dalej</span>
                        </button>
                    </form>

                    <!-- step 3 -->
                    <form v-if="activeStep === 3" class="form form-login" @submit.prevent="postRemindPassword">
                        <div class="text-left mt-10 mb-10">
                            <button class="link" @click="goToStep(2)">
                                <span class="pd-0">&larr; Wróć do hasła</span>
                            </button>
                        </div>
                        <h1 class="h1">Reset hasła</h1>
                        <!--<p class="text-center mt-0">Na podany numer telefonu wyślemy tymczasowe hasło:</p>-->
                        <div class="form-group">
                            <label>Podaj numer telefonu:</label>
                            <input v-model="username" type="tel" :class="{'input-error' : errors.username }"
                                   placeholder="Podaj swój numer telefonu" required/>
                        </div>
                        <p class="error" v-if="errors.username">
                            <svg class="voxion">
                                <use xlink:href="#icon-alert"></use>
                            </svg>
                            <span v-text="errors.username"></span>
                        </p>
                        <button class="btn btn-primary" type="submit" :disabled=loading>
                            <span v-if="loading"><span class="loader"></span></span>
                            <span v-else>Przypomnij mi hasło</span>
                        </button>
                    </form>

                    <span v-if="!showRegulations" class="link terms-link" @click="goToRegulations">Regulamin</span>
                </div>
            </ion-col>
        </ion-row>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import Splash from './../components/Splash.vue'

    import Firestore from '@/services/Firestore';
    import Platform from '../helpers/Platform.js';
    import { Capacitor } from '@capacitor/core'

    export default {
        name: 'Login',
        components: {Splash},
        data () {
            return {
                blockedScreen: true,
                showLogin: true,
                activeStep: 1,
                loading: false,
                errors: [],

                inputLabel: '',
                buttonLabel: '',

                username: '',
                password: '',

                showRegulations: false,
                approvalsCollection: null,
                checkboxes: [],
                lockUserInput: false
            }
        },
        mounted(){
            setTimeout(() => {
                this.blockedScreen = false; // unblock screen overflow hidden;
                this.$refs.splashComponent.splashAnimateOut = true;
            }, 5000);
        },
        computed: {
            loginButtonDisabled() {
                if (this.username !== '' && this.username.length >= 9) {
                    if (this.approvalsCollection) {
                        if (this.checkboxes.length > 0) {
                            return false
                        } else {
                            return true
                        }
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            }
        },
        methods: {
            checkUser() {
                if (this.approvalsCollection === null || this.showRegulations === true) {
                    if (this.checkboxes.length > 0) {
                        this.getToken();
                    }
                    this.getApprovals()
                } else {
                    // bypass
                    this.getToken();
                }
            },
            getApprovals() {
                this.loading = true;
                api.get('/approvals/' + this.username).then(response => {
//                    this.errors = [];
                    this.loading = false;

                    this.showRegulations = response.data.regulations;
                    this.approvalsCollection = response.data.data;
                    this.lockUserInput = true;

                    // bypass
                    if (this.approvalsCollection.length === 0 && this.showRegulations === false) {
                        this.getToken()
                    }
                })
            },
            getToken() {
                let data = {
                    'username': this.username,
                    'approvals': this.checkboxes
                };
                api.post('/authorization/token/', data).then(response => {
                    this.errors = [];
                    // check if user exist
                    if (response.data.user_exists === true) {
                        this.inputLabel = 'Podaj hasło';
                        this.buttonLabel = 'Zaloguj'
                    } else {
                        this.inputLabel = 'Twoje tymczasowe hasło';
                        this.buttonLabel = 'Dalej';
                        this.password = response.data.data.token;
                    }
                    this.loading = false;
                    this.goToStep(2);
                }).catch(err => {
                    this.loading = false;
                    if (err.response && err.response.data)
                        this.errors = err.response.data.errors
                    if (err.response.status === 500) {
                        this.$ionic.toastController
                            .create({
                                message: 'Błąd serwera.',
                                duration: 2000,
                                mode: 'md'
                            })
                            .then(a => a.present());
                    }
                })
            },
            postLogin() {
                this.loading = true;
                const { username, password } = this;
                this.$store.dispatch('AUTH_REQUEST', { username, password })
                .then(() => {
                    this.errors = [];
                    setTimeout(()=> {
                      Firestore.firestoreInit();
                    }, 5000);

                    this.$ionic.toastController
                        .create({
                            message: 'Zalogowano poprawnie.',
                            duration: 3000,
                            mode: 'md'
                        })
                        .then(a => a.present());

                    this.loading = false;
                    this.$router.push({ name: 'Index' });
                    this.showLogin = false; // hide login form while screen re-draw
                })
               .catch(err => {
                    this.loading = false;
                    if(err.response && err.response.data)
                      this.errors = err.response.data.errors

                    if(err.response.status === 401 && err.response.data.blocked) { // blocked account - go to remind pass
                        this.password = '';
                        this.goToStep(3);
                        this.$ionic.toastController
                          .create({
                            message: 'Trzykrotnie podano nieprawidłowe hasło. Rozpocznij proces odzyskiwania hasła.',
                            duration: 4000
                          })
                          .then(a => a.present())
                    }
                })
            },
            postRemindPassword() {
                this.loading = true;
                let data = {'username': this.username};
                api.post('/authorization/remind-password', data).then(response => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.code === 200) {
                        this.goToStep(2);
                        this.$ionic.toastController
                            .create({
                                message: 'SMS z hasłem został wysłany.',
                                duration: 2000
                            })
                            .then(a => a.present())
                    }
                }).catch(err => {
                    this.loading = false;
                    if (err.response && err.response.data)
                        this.errors = err.response.data.errors
                })
            },
            goToStep(step) {
                this.errors = [];
                this.activeStep = step;
            },
            goToRegulations() {
                this.$router.push({name: 'RegulationsIndex'})
            },
            handleCheckbox(event, id, name) {
                if (event.detail.checked === true) {
                    this.checkboxes.push({'id': id, 'name': name, 'value': event.detail.checked})
                } else {
                    let index = this.checkboxes.map(function (item) {
                        return item.id
                    }).indexOf(id);
                    this.checkboxes.splice(index, 1)
                }
            },
            unlockUserInput() {
                this.errors = [];
                this.username = '';
                this.showRegulations = false;
                this.lockUserInput = false;
                this.approvalsCollection = null
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fade-in {
        opacity: 1;
    }

    .screen-blocked {
        overflow: hidden;
    }

    .approval-list {
        margin-top: 20px;
        .item-approval {
            display: flex;
            width: 100%;
            .item-input {
                width: 30px;
                max-width: 30px;
                min-width: 30px;
            }
            .item-description {
                margin: 0 7px 10px;
            }
        }
    }

    .terms-link {
        display: inline-block;
        width: 100%;
        padding: 20px;
        text-align: center;
    }

</style>
